var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubEmotionLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4393 0.217407C16.6093 0.217407 18.7393 3.19741 18.7393 5.97741C18.7393 8.79241 16.5293 11.3524 14.2993 13.2087L13.868 13.559L13.4397 13.8911L13.0181 14.2041L12.6064 14.4974L12.2085 14.7703L11.8276 15.0219L11.4674 15.2516L10.9737 15.5536L10.4206 15.8727L10.1002 16.0463L9.82147 16.1854L9.7537 16.2138C9.74668 16.2162 9.74184 16.2174 9.73926 16.2174L9.72482 16.2138L9.65705 16.1854L9.37834 16.0463L9.05793 15.8727L8.65528 15.6425L8.1823 15.3581L7.83379 15.1396L7.46284 14.8988L7.07298 14.6365C7.00663 14.591 6.93963 14.5446 6.87207 14.4974L6.46047 14.2041L6.03878 13.8911L5.61053 13.559L5.17926 13.2087C2.94926 11.3524 0.739258 8.79241 0.739258 5.97741C0.739258 3.19741 2.86926 0.217407 6.03926 0.217407C7.85926 0.217407 9.04926 1.12741 9.73926 1.92741C10.4293 1.12741 11.6193 0.217407 13.4393 0.217407Z",
    fill: "url(#paint0_linear_7022_32454)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7022_32454",
    x1: 9.90693,
    y1: 0.217407,
    x2: 9.90693,
    y2: 16.2174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF375F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubEmotionLove);
export default __webpack_public_path__ + "static/media/sub_emotion_love.ab58a6925d9d12e055d0656eb3b4af37.svg";
export { ForwardRef as ReactComponent };